/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type {
	SidebarConfigData,
	SidebarConfigQuery,
} from '@atlassian/jira-navigation-types/src/types.tsx';
/**
 * Generates a URL tailored for retrieving sidebar configurations, allowing for dynamic
 * customization based on user-defined criteria. This facilitates the flexible integration
 * of sidebar elements in applications.
 */
export const formSidebarConfigRequest = (
	requestQuery: SidebarConfigQuery,
	version = '2',
	queryParams?: string,
): string => {
	const { pageType, identifierValue, identifierType, exclude } = requestQuery || {};
	const params: Record<string, string> = {
		exclude: ['webItems.reports', 'webItems.home', 'webItems.gin', exclude]
			.filter(Boolean)
			.join(','),
	};
	let path = '';
	if (pageType && identifierValue != null) {
		path = `${pageType}/${identifierValue}`;
	} else if (identifierType === 'boardId' && identifierValue != null) {
		path = `board/${identifierValue}`;
	} else if (identifierValue != null) {
		path = `project/${identifierValue}`;
	} else {
		path = 'product';
		const { projectId, projectKey } = requestQuery || {};
		// Connect apps rely on project context even for the global/product scoped webItems
		const projectIdOrKey = projectId || projectKey;
		if (projectIdOrKey) {
			params.projectIdOrKey = projectIdOrKey;
		}
	}
	const queryString = [new URLSearchParams(params).toString(), queryParams]
		.filter(Boolean)
		.join('&');
	return `/rest/navigation/${version}/${path}?${queryString}`;
};

export const fetchSidebarConfig = async (
	requestQuery: SidebarConfigQuery,
	queryParams?: string,
): Promise<SidebarConfigData> => {
	const sidebarUrl = formSidebarConfigRequest(requestQuery, undefined, queryParams);
	return fetchJson(sidebarUrl);
};
